import React, { useState } from "react";
import CollapseSection from "./CollapseSection";
import { productPageSettings } from "../../../themes/productPageSettings";
import { PRODUCT_COLORS, PRODUCT_TEXTS } from "../../../themes/pageCustomization";

const GROUPS = [
  {
    id: "colors",
    title: "Colors",
    text: "Background, text, buttons, stock, and the delivery strip.",
    keys: PRODUCT_COLORS.map((color) => color.key),
  },
  {
    id: "words",
    title: "Words",
    text: "Every label on the page, in your own words.",
    keys: PRODUCT_TEXTS.map((item) => item.key),
  },
  {
    id: "layout",
    title: "Layout and photos",
    text: "How big the product photos are and where the details sit on a computer.",
    keys: [
      "productGalleryWidth",
      "productImageSize",
      "productThumbs",
      "productImageZoom",
      "productImageFrame",
      "productPageWidth",
      "productInfoAlign",
      "productInfoStyle",
      "productShowBreadcrumbs",
      "productShowRating",
      "productShowBadges",
    ],
  },
  {
    id: "buy-box",
    title: "Name, price, and buttons",
    text: "Words, sizes, and which parts of the buy box show.",
    keys: [
      "productTitleSize",
      "productPriceColor",
      "productShowCategory",
      "productShowStock",
      "productAddLabel",
      "productShowBuyNow",
      "productBuyLabel",
      "productShowTrust",
      "productTrustAuthentic",
      "productTrustReturns",
      "productDescriptionTitle",
    ],
  },
  {
    id: "phone",
    title: "On a phone",
    text: "How the product name, price, and Buy Now button sit on a small screen.",
    keys: ["productMobileAlign", "productMobileBuyFull"],
  },
  {
    id: "sections",
    title: "Sections below the product",
    text: "Reviews, recently viewed, and your own text, in any order.",
    keys: ["productPageSections"],
  },
];

function PhonePreview({ settings }) {
  const look = productPageSettings(settings || {});
  const centered = look.mobileAlign === "center";
  return (
    <div className="border rounded-3 p-3 mb-3 bg-white">
      <div className="text-muted small mb-2">Phone preview</div>
      <div
        style={{
          maxWidth: "280px",
          margin: "0 auto",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "16px",
          textAlign: centered ? "center" : "left",
        }}
      >
        <div style={{ fontSize: "11px", letterSpacing: "0.08em", color: "#6b7280" }}>MEN</div>
        <div style={{ fontSize: "20px", fontWeight: 700, margin: "4px 0 8px" }}>Product name</div>
        <div style={{ fontWeight: 700, marginBottom: "12px" }}>Rs. 1,999</div>
        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            justifyContent: centered ? "center" : "flex-start",
            marginBottom: "8px",
          }}
        >
          <span style={{ border: "1px solid #e5e7eb", borderRadius: "999px", padding: "6px 12px", fontSize: "13px" }}>1</span>
          <span style={{ background: "#111", color: "#fff", borderRadius: "8px", padding: "8px 14px", fontSize: "13px" }}>Add to Cart</span>
        </div>
        <div
          style={{
            background: "#111",
            color: "#fff",
            borderRadius: "8px",
            padding: "10px 14px",
            fontSize: "14px",
            fontWeight: 700,
            width: look.mobileBuyFull ? "100%" : "auto",
            display: look.mobileBuyFull ? "block" : "inline-block",
            marginLeft: centered && !look.mobileBuyFull ? "auto" : undefined,
            marginRight: centered && !look.mobileBuyFull ? "auto" : undefined,
          }}
        >
          Buy Now
        </div>
      </div>
    </div>
  );
}

export function ProductSettings({ fields, settings, renderField }) {
  const [open, setOpen] = useState("layout");
  const byKey = {};
  (fields || []).forEach((field) => {
    byKey[field.key] = field;
  });

  return (
    <div>
      <PhonePreview settings={settings} />
      {GROUPS.map((group) => (
        <CollapseSection
          key={group.id}
          title={group.title}
          text={group.text}
          open={open === group.id}
          onToggle={() => setOpen(open === group.id ? "" : group.id)}
        >
          {group.keys.map((key) => (byKey[key] ? <div key={key}>{renderField(byKey[key])}</div> : null))}
        </CollapseSection>
      ))}
    </div>
  );
}
